var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionButton',{staticClass:"spectrum-CycleButton",attrs:{"quiet":_vm.quiet},nativeOn:{"click":function($event){return _vm.incrementIndex($event)}}},_vm._l((_vm.vForable(_vm.items)),function(ref,index){
var key = ref.key;
var item = ref.item;
return _c('Icon',{key:key,staticClass:"spectrum-CycleButton-item",class:{
      'is-selected': _vm.selectedIndex === index,
    },attrs:{"name":item.iconName,"size":_vm.size}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }